import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import {spanWrapAllLetters} from '../../helpers/texthelper';
import ScrollMagic from 'scrollmagic';
import {PopInBodyScrollEffect} from '../anim8.effect.scroll.text-popin-section';

export default class Anim8_footer {


	constructor(scroll, sceneFactory, controller, domElem) {

		if( !domElem ) {
			console.error('DOM ELEMENT FOR FOOTER NOT FOUND');
			return;
		}

		this.animatedIn = false;
		this.animatedOut = false;
		this.useScrollTrigger = true;

		this.domElem = domElem;
		this.sceneElemName = this.domElem.getAttribute('data-anchor').toLowerCase();
		this.sceneDuration = this.domElem.getAttribute('data-duration');
		this.sceneOffset = this.domElem.getAttribute('data-offset');
		this.sceneTriggerHook = this.domElem.getAttribute('data-trigger-hook');

		this.dimensions = domElem.getBoundingClientRect();
		

		//this.setTextLetters();

		this.initTimeline();

		if( ![undefined,null].includes(scroll) && ![undefined,null].includes(controller) ) {
			this.initScrollMagic(scroll, sceneFactory, controller);
		} else {
			//this.defaultTween();
		}

		console.warn("[Anim8_footer.js] loaded");

		this.elemForms = this.domElem.querySelectorAll('.forminator-row');
		this.elemWidgetList = this.domElem.querySelectorAll('.elementor-widget-icon-list');

		return this.timeline;
		
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 0,
			defaults: {
				ease: "power1.inOut"
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("Anim8_footer.js finished");
			},
		});
	}

	scrollTriggerOptions() {

		let initialised = false;

		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			start: 'top bottom', // when the top of the trigger hits the top of the viewport
			//end: `+=${(this.dimensions.height*.75)}`,
			end: `+=${(this.dimensions.height*.95)}`,
			//duration: 1.5,
			scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			//markers: {startColor:"green", endColor:"red", fontSize:"12px"},
			onToggle: self => console.log(`${this.sceneElemName} active:`, self.isActive),
			//onEnter: (({progress, direction, isActive}) =>{})
			onEnter: (({progress, direction, isActive}) =>{
				/**/
				if( initialised === false ) {

					gsap.fromTo(
							this.domElem.querySelectorAll('.forminator-row'), 
							{
								y: '100%',
								//rotationY: -90,
								autoAlpha: 0
							},
							{
								y: '0%',
								//rotationY: 0,
								autoAlpha: 1,
								stagger: .2,
								overwrite: false,
								ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								//ease: Power0.easeOut
							}
						);

					gsap.fromTo(
							this.domElem.querySelectorAll('.elementor-widget-icon-list'),
							{
								y: '100%',
								autoAlpha: 0
							},
							{
								y: '0%',
								autoAlpha: 1,
								stagger: .15,
								overwrite: false,
								//duration: 1,
								ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								//ease: Power0.easeOut
							}
						)
					/** /
					this.animatedText = new PopInBodyScrollEffect(this.domElem.querySelector('.text-wrapper'));
					this.animatedText.play();
					initialised = true;

					this.animatedText.textElement.addEventListener( 'animationComplete', (e)=>{
						//console.info('BlurScrollEffect Complete');

						gsap.fromTo(
							this.domElem.querySelectorAll('.forminator-row'), 
							{
								y: '100%',
								//rotationY: -90,
								autoAlpha: 0
							},
							{
								y: '0%',
								//rotationY: 0,
								autoAlpha: 1,
								stagger: .2,
								overwrite: false,
								ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								//ease: Power0.easeOut
							}
						);

						gsap.fromTo(
							this.domElem.querySelectorAll('.elementor-widget-icon-list'),
							{
								y: '100%',
								autoAlpha: 0
							},
							{
								y: '0%',
								autoAlpha: 1,
								stagger: .15,
								overwrite: false,
								//duration: 1,
								ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								//ease: Power0.easeOut
							}
						)
					});
					/**/
				} else {

					for (let index = 0; index < this.elemForms.length; index++) {
						const element = this.elemForms[index];
						element.style.opacity = 0
					}

					for (let index = 0; index < this.elemWidgetList.length; index++) {
						const element = this.elemWidgetList[index];
						element.style.opacity = 0
					}
					//this.animatedText.play();
					gsap.fromTo(
							this.domElem.querySelectorAll('.elementor-widget-icon-list'),
							{
								y: '100%',
								autoAlpha: 0
							},
							{
								y: '0%',
								autoAlpha: 1,
								stagger: .15,
								overwrite: false,
								//duration: 1,
								ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								//ease: Power0.easeOut
							}
						)
				}
				/**/
			}),
		}

	}

	initScrollMagic(scroll, sceneFactory, controller) {
	
		this.scrollMagicScene = new ScrollMagic.Scene({
			triggerElement: this.domElem,
			duration: this.sceneDuration,
			offset: this.sceneOffset,
			triggerHook: this.sceneTriggerHook
		})
		.setTween(this.defaultTween())
		.addTo(controller)
		.setClassToggle( this.domElem, 'active');

		scroll.options.scenes.push(this.scrollMagicScene);
	}

	setTextLetters() {
		const letters = this.domElem.querySelectorAll('.text-wrapper .letters');
		if( letters ) {
			letters.forEach((lettContainer)=>{
				spanWrapAllLetters(lettContainer);
			});
		}
	}

	defaultTween() {

		return this.timeline
		.fromTo(
			this.domElem.querySelectorAll('.forminator-row'), 
			{
				y: '100%',
				//rotationY: -90,
				autoAlpha: 0
			},
			{
			   	y: '0%',
				//rotationY: 0,
				autoAlpha: 1,
				stagger: .2,
				overwrite: false,
				//ease: Power0.easeInOut
				//immediateRender: false,
				//ease: Power0.easeInOut
				ease: Power0.easeOut
			}
			
		)
		.fromTo(
			this.domElem.querySelectorAll('.elementor-widget-icon-list'), 
			{
				y: '100%',
				//rotationY: -90,
				autoAlpha: 0
			},
			{
			   	y: '0%',
				//rotationY: 0,
				autoAlpha: 1,
				stagger: .15,
				overwrite: false,
				//duration: 1,
				ease: Power0.easeInOut
				//immediateRender: false,
				//ease: Power0.easeInOut
				//ease: Power0.easeOut
			}
		)
		
		
	}

}
